// extracted by mini-css-extract-plugin
export default {"AddNewGoalPop":"AddNewGoalPop_AddNewGoalPop__8YsY-","modalBody":"AddNewGoalPop_modalBody__m+2FW","formControl":"AddNewGoalPop_formControl__yw3IW","add":"AddNewGoalPop_add__iBfNU"};